module.exports = __webpack_public_path__ + "static/img/aiGif.cb355ad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aiGif.gif
// module id = V6Lg
// module chunks = 2